import {ChangeDetectionStrategy, Component, input, InputSignal} from "@angular/core";
import {NgClass} from '@angular/common';
import {IconComponent} from "../icon/icon.component";

@Component({
    selector: "woa-toggle",
    templateUrl: "./toggle.component.html",
    styleUrl: "./toggle.component.scss",
    imports: [
        IconComponent,
        NgClass
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleComponent {
    public readonly active: InputSignal<boolean> = input.required<boolean>();
}
